module.exports = __webpack_public_path__ + "src/img/camera.3ed11fa8.svg";